import { render, staticRenderFns } from "./StockInfoHome.vue?vue&type=template&id=0fd6829c&scoped=true&"
import script from "./StockInfoHome.vue?vue&type=script&lang=js&"
export * from "./StockInfoHome.vue?vue&type=script&lang=js&"
import style0 from "./StockInfoHome.vue?vue&type=style&index=0&id=0fd6829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6829c",
  null
  
)

export default component.exports